// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"165":"04cfcc0e","796":"ae39b6c8"}[chunkId] + ".chunk.js";
};